export const LOADING = 'LOADING';
export const READY = 'READY';
export const PLAY = 'PLAY';
export const PLAYPAUSE = 'PLAYPAUSE';
export const STOP = 'STOP';
export const UPDATE_DURATION = 'UPDATE_DURATION';
export const UPDATE_CURRENT_TIME = 'UPDATE_CURRENT_TIME';
export const CLOSEPLAYER = 'CLOSEPLAYER';
export const SET_VOLUME = 'SET_VOLUME';